import React, { memo } from "react";

const CircleArrowButton: React.FC = memo(() => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.44 11.1734C7.58667 11.32 7.77333 11.3933 8 11.3933C8.22667 11.3933 8.41333 11.32 8.56 11.1734L11.04 8.69335C11.1867 8.54668 11.26 8.36322 11.26 8.14295C11.26 7.92322 11.18 7.73335 11.02 7.57335C10.8733 7.42668 10.6867 7.35335 10.46 7.35335C10.2333 7.35335 10.0467 7.42668 9.9 7.57335L8 9.47335L6.08 7.55335C5.93333 7.40668 5.75013 7.33335 5.5304 7.33335C5.31013 7.33335 5.12 7.41335 4.96 7.57335C4.81333 7.72002 4.74 7.90668 4.74 8.13335C4.74 8.36002 4.81333 8.54668 4.96 8.69335L7.44 11.1734ZM8 16.9333C6.89333 16.9333 5.85333 16.7232 4.88 16.3029C3.90667 15.8832 3.06 15.3134 2.34 14.5934C1.62 13.8734 1.05013 13.0267 0.6304 12.0533C0.210133 11.08 0 10.04 0 8.93335C0 7.82668 0.210133 6.78668 0.6304 5.81335C1.05013 4.84002 1.62 3.99335 2.34 3.27335C3.06 2.55335 3.90667 1.98322 4.88 1.56295C5.85333 1.14322 6.89333 0.93335 8 0.93335C9.10667 0.93335 10.1467 1.14322 11.12 1.56295C12.0933 1.98322 12.94 2.55335 13.66 3.27335C14.38 3.99335 14.9499 4.84002 15.3696 5.81335C15.7899 6.78668 16 7.82668 16 8.93335C16 10.04 15.7899 11.08 15.3696 12.0533C14.9499 13.0267 14.38 13.8734 13.66 14.5934C12.94 15.3134 12.0933 15.8832 11.12 16.3029C10.1467 16.7232 9.10667 16.9333 8 16.9333Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { CircleArrowButton };
